document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[id^="locator-bars-"]');
  sections.forEach(function (el) {
    var sectionId = el.id.replace('locator-bars-', '');
    tryGeolocation(sectionId);
  });
});

function tryGeolocation(sectionId) {
  if (!navigator.geolocation) return;
  navigator.geolocation.getCurrentPosition(
    function (pos) {
      onGeoSuccess(sectionId, pos.coords.latitude, pos.coords.longitude);
    },
    function () {}
  );
}

function onGeoSuccess(sectionId, userLat, userLng) {
  var el = document.getElementById('locator-bars-' + sectionId);
  if (!el) return;
  var bars = JSON.parse(el.textContent);

  var withDistance = bars
    .filter(function (b) { return b.lat !== null && b.lng !== null; })
    .map(function (b) {
      return Object.assign({}, b, { distance: haversine(userLat, userLng, b.lat, b.lng) });
    });

  var nearest = withDistance
    .filter(function (b) { return b.distance <= 30; })
    .sort(function (a, b) { return a.distance - b.distance; })
    .slice(0, 3);

  if (nearest.length === 0) {
    annotateStaticCards(sectionId, withDistance);
    return;
  }

  var label = document.getElementById('locator-nearby-label-' + sectionId);
  if (label) { label.textContent = label.dataset.nearestLabel; label.style.display = ''; }

  renderLocatorCards(sectionId, nearest);
}

function annotateStaticCards(sectionId, barsWithDistance) {
  var grid = document.getElementById('locator-cards-' + sectionId);
  if (!grid) return;

  var distanceByHandle = {};
  barsWithDistance.forEach(function (b) { distanceByHandle[b.handle] = b.distance; });

  grid.querySelectorAll('.locator-card[data-bar-handle]').forEach(function (card) {
    var handle = card.getAttribute('data-bar-handle');
    if (!(handle in distanceByHandle)) return;
    var infoBlock = card.querySelector('.mt-3');
    if (!infoBlock) return;
    var p = document.createElement('p');
    p.className = 'mt-1 text-sm opacity-50';
    p.textContent = formatDistance(distanceByHandle[handle]);
    infoBlock.appendChild(p);
  });
}

function renderLocatorCards(sectionId, nearestBars) {
  var grid = document.getElementById('locator-cards-' + sectionId);
  if (!grid) return;
  grid.innerHTML = nearestBars.map(function (bar) {
    return [
      '<div class="locator-card min-w-0" data-bar-handle="' + escHtml(bar.handle) + '">',
        '<a href="' + escHtml(bar.url) + '" class="block">',
          '<div class="relative overflow-hidden rounded-2xl" style="aspect-ratio: 1 / 1;">',
            bar.imageUrl
              ? (function(src) {
                  var srcset = [400, 600, 800, 1000].map(function(w) { return src.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', ');
                  return '<img src="' + escHtml(src) + '" srcset="' + escHtml(srcset) + '" sizes="(min-width: 990px) calc(33vw - 2rem), (min-width: 769px) calc(50vw - 2rem), calc(100vw - 2rem)" alt="' + escHtml(bar.name) + '" loading="lazy" class="absolute inset-0 w-full h-full object-cover' + (bar.isClosed ? ' location-image--closed' : '') + '">';
                })(bar.imageUrl)
              : '<div class="absolute inset-0 bg-scheme-placeholder-background"></div>',
            bar.isClosed
              ? '<div class="absolute" style="top: 1rem; left: 1rem;"><span class="location-status-badge--closed inline-flex items-center rounded-full px-3 pt-1 text-theme-basic font-medium">' + escHtml(bar.closedLabel) + '</span></div>'
              : '',
          '</div>',
        '</a>',
        '<div class="mt-3">',
          '<a href="' + escHtml(bar.url) + '" class="block">',
            '<h3 class="font-heading break-words text-scale-n1">' + escHtml(bar.name) + '</h3>',
          '</a>',
          bar.street
            ? '<p class="mt-1 text-base opacity-60">' + escHtml(bar.street) + ', ' + escHtml(bar.city) + '</p>'
            : '',
          '<p class="mt-1 text-sm opacity-50">' + formatDistance(bar.distance) + '</p>',
        '</div>',
      '</div>',
    ].join('');
  }).join('');
}

function haversine(lat1, lng1, lat2, lng2) {
  var R = 6371;
  var dLat = toRad(lat2 - lat1);
  var dLng = toRad(lng2 - lng1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function toRad(deg) {
  return deg * (Math.PI / 180);
}

function formatDistance(km) {
  if (km < 1) return Math.round(km * 1000) + ' m';
  return (km < 10 ? km.toFixed(1) : Math.round(km)) + ' km';
}

function escHtml(str) {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
